import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';

import { CustomAlert, Text } from '../../../../../../shared/uiComponents';
import { PRIMARY } from '../../../../../../shared/Helpers/colors';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import {
	getMoveTargetOptions,
	getTargets,
	moveTarget,
} from '../../../../../../redux/State/clientSlice/programTargetSlice';
import { RightLeftLargeIcon } from '../../../../../../shared/Assets/svgIcons';

const MoveProgramContent = ({ id, programId, onClose }: { id: string; onClose: () => void; programId: string }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);

	const options = useSelector((state) => state.programTarget.moveOptions);
	const loading = useSelector((state) => state.programTarget.loadingTargetOptions);

	useEffect(() => {
		if (!id || !programId) return;
		dispatch(getMoveTargetOptions({ id, programId }));
	}, [id, programId, dispatch]);

	const moveTargetHandler = (toProgramId: string) => {
		if (!id || !programId || !toProgramId) return;

		dispatch(moveTarget({ id, programId, toProgramId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				onClose();
				toast('Successful');
			})
			.catch(errorNormalizer);
	};

	return (
		<div>
			{loading ? (
				<div style={{ width: 'max-content', margin: 'auto' }}>
					<CircularProgress color="inherit" />
				</div>
			) : (
				options.map((option) => (
					<div
						style={{ display: 'flex', justifyContent: 'space-between' }}
						className="marginBottom8"
						key={option.program.id}
					>
						<Text title={`${option.skillArea.name} -> ${option.program.name}`} type="psm" fontWeight="semiBold" />
						<Text
							title="Move"
							type="psm"
							fontWeight="semiBold"
							color={PRIMARY.LIGHT[16]}
							onClick={() => moveTargetHandler(option.program.id)}
						/>
					</div>
				))
			)}
		</div>
	);
};

const Move = ({ id, programId }: { id: string; programId: string }) => {
	const [openMove, setOpenMove] = useState<boolean>(false);

	return (
		<>
			<div className="actionRow" onClick={() => setOpenMove(true)}>
				<div className="actionIcon">
					<RightLeftLargeIcon />
				</div>
				<div className="actionContent">
					<Text title="Move" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				open={openMove}
				onClose={() => setOpenMove(false)}
				title="Choose program to move"
				Content={() => <MoveProgramContent id={id} programId={programId} onClose={() => setOpenMove(false)} />}
			/>
		</>
	);
};

export default Move;
